import _ from 'lodash'
import type {CssValue} from '../../constants'
import type {DecoratedStyleProperty} from '../../../../../decorations/styleProperties/constants'
import {hasValidKeys} from '../utils/object'
import {deserializeDisabled, serializeDisabled} from '../utils/disabled'
import {deserializeString} from '../utils/string'

const DEFAULT_VALUE: string = 'initial'
const VALID_KEYS = new Set(['value', 'additionalData'])
const VALID_ADDITIONAL_DATA_KEYS = new Set(['boxShadowToggleOn'])

const serializeFontValue = (fontValue?: DecoratedStyleProperty['value']): string => {
    if (!fontValue) {
        return DEFAULT_VALUE
    }

    return fontValue
}

const deserializeFontValue = (val: CssValue): DecoratedStyleProperty['value'] => {
    if (val === DEFAULT_VALUE) {
        return DEFAULT_VALUE
    }

    return deserializeString(val)
}

const serialize = (val: any): CssValue | undefined => {
    if (!_.isPlainObject(val) || _.isEmpty(val) || !hasValidKeys(val, VALID_KEYS)) {
        return undefined
    }

    const {value, additionalData} = val

    const serializedValue = serializeFontValue(value)

    if (additionalData) {
        if (!hasValidKeys(additionalData, VALID_ADDITIONAL_DATA_KEYS)) {
            return undefined
        }

        const {boxShadowToggleOn} = additionalData

        if (boxShadowToggleOn === 'false') {
            return serializeDisabled(serializedValue)
        }
    }

    return serializedValue
}

const deserialize = (rule: CssValue): DecoratedStyleProperty | undefined => {
    const styleProperty: DecoratedStyleProperty = {}

    let val = deserializeDisabled(rule)
    styleProperty.additionalData = {boxShadowToggleOn: (!val).toString()}
    val ??= rule

    const fontValue = deserializeFontValue(val)
    if (!fontValue) {
        return undefined
    }

    if (fontValue !== DEFAULT_VALUE) {
        styleProperty.value = fontValue
    }

    return styleProperty
}

export default {
    serialize,
    deserialize
}
